<div class="container">
  <div class="header">
    <span class="label">{{ header }}</span>
    <cs-icon-button
      icon="fi-x"
      iconFontSize="12"
      size="12"
      color="secondary"
      (buttonClick)="onCancel()"
    ></cs-icon-button>
  </div>
  <div class="body-container">
    <div class="body">
      <div class="text">
        {{ message }}
        <span class="mark" (click)="contactSupport()">{{ 'contact_support' | translate }}</span>
      </div>
    </div>
    <div class="btn">
      <cs-button [label]="'go_back' | translate" [color]="'primary'" (buttonClick)="onConfirm()"></cs-button>
    </div>
  </div>
</div>
